import { loadModules } from 'esri-loader';
import jscookie from 'js-cookie'
import { AUTH_API_COOKIE } from '../modules/user'
import { AUTH_COOKIE } from '../modules/user'


const state = {
	stateMap: null, 
	interiorMappingDMSL: null,
  	highlightBuilding: null,  
 	highlightRoomsByKey: null,
  	clearGraphics: null,	
  	removeGraphic: null,
  	highlightRoom: null,	
  	applyLabels: null,

  	highlightLayer: null,
  	mapReady: false, 
  	siteExtents: {},
  	selectionRectangle      : null,
	drawEndHandle              : null,

}

const mutations = {
	setMap (state, payload) {	    
		state.stateMap = payload
  	},
  	setInteriorMappingDMSL (state, payload) {	    
		state.interiorMappingDMSL = payload
  	},
  	setMapReady (state, payload) {
  		state.mapReady = payload
  	},
	setHighlightBuildingFunction (state, payload) {
		state.highlightBuilding = payload
	},
	setHighlightRoomsByKeyFunction (state, payload) {
		state.highlightRoomsByKey = payload
	},
	setClearGraphicsFunction (state, payload) {
		state.clearGraphics = payload
	},
	setHighlightRoomFunction (state, payload) {
		state.highlightRoom = payload
	},
	setRemoveGraphicFunction (state, payload) {
		state.removeGraphic = payload
	},
	setApplyLabelsFunction (state, payload) {
		state.applyLabels = payload
	},	
	addSiteExtent (state, payload) {
		// Add to key value pairs
		state.siteExtents[payload.siteID] = payload.extent
	},
}

const getters = {

}


const actions = {
	
	addLayer ({state}, payload) {
		//console.log("Action: Add Layer")
		const vm = state
		loadModules(["esri/map",])
		.then(([Map]) => {
			state.stateMap.addLayer(payload)
		})
	},

	useSelectRectangle({state, rootState, dispatch}) {
		loadModules(['esri/toolbars/draw', 'esri/graphic'])
		.then(([Draw, Graphic]) => {
			if (state.drawEndHandle) { state.drawEndHandle.remove() } // Prevent buildup of event handlers

			// Clear Existing
	      	//dispatch('clearMultiSelectRoomArray')

	      	// Draw new Rectangle
			state.selectionRectangle = new Draw(state.stateMap)	
	        state.stateMap.disableMapNavigation();
	        state.stateMap.setMapCursor("crosshair");
	        state.selectionRectangle.activate('extent');	

			
	      	// When finished, re-enable navigation, selects rooms, deactivate selection tool.
	      	state.drawEndHandle = state.selectionRectangle.on("draw-end", (evt) => { 
	      		//rootState.mapFunctions.map.graphics.add(new Graphic(evt.geometry, rootState.mapSymbols.roomHighlightSymbol))	      		      		      		
          		state.stateMap.enableMapNavigation()
          		dispatch('selectRooms', evt.geometry)	
          		state.selectionRectangle.deactivate()	
          		state.stateMap.setMapCursor("default");
	      	})	      	
      	})
    },

    // Geometric Selection of Rooms (Lasso tool)

    selectRooms({state, getters, rootState, commit, dispatch}, extent) {
		loadModules(['esri/tasks/QueryTask', 'esri/tasks/query'])
		.then(async ([QueryTask, Query]) => {
		let esriToken     = jscookie.get(AUTH_COOKIE)	

			// Set progress bar on
			//commit('setMapLoading', true)

			// Clear selection first
			//dispatch('clearMultiSelectRoomArray')

			// Setup a Query for this extent
			var features = []
			const serviceURL = rootState.user.viewRestricted ? getters.secureFloorURL[rootState.ui.currentFloor] + '?token='+esriToken : getters.floorURL[rootState.ui.currentFloor]

			//console.log("serviceURL", serviceURL)
			var queryTask = new QueryTask(serviceURL)
			var query = new Query();
			query.returnGeometry = true;
			query.geometry = extent
			query.outFields = ["*"];

			// Execute the Query
			let results = await queryTask.execute(query)
			//commit('setMapLoading', false)

			// Process the Results.
			features = results.features
			if (features.length > 0) {
				features.forEach(async function(feature) {
					let room = await dispatch('getRoom', feature.attributes['ROOMEXT.roomKey'])
					//dispatch('toggleInMultiSelectRoomArray', room)
					dispatch('addToMultiSelectRoomArray', room)											
				})
			} 
		})
	},

	// Get a room object.  Search local buildingRooms first.  If not found.  Fetch from database
	async getRoom ({state, rootState, commit, dispatch}, roomKey) {
		console.log("getRoom: " + roomKey)
		let localRoom = rootState.space.buildingRooms.find(room => room.roomKey == roomKey)
		if (localRoom) {
			return localRoom
		} else {
			console.log("Room not found local.  Perform Fetch")
			let bldgAlpha = roomKey.split('+')[0]
			let number	  = roomKey.split('+')[1]	
			let localRoom = await dispatch('fetchFullRoom', { 'bldgAlpha': bldgAlpha, 'number': number, 'noSet': true })
			return localRoom.Message ? null : localRoom  // if there is a message, this failed.  Return null.
		}
   	},

	// This no longer has any use
	updateLayerVisibility({state, rootState}, floor) {
			//console.log("Update Layer Visibility")
	},

	addGraphicsLayer ({state}, payload) {
		//console.log("Action: Add Graphics Layer")
		const vm = state
		
		loadModules(["esri/map", "esri/layers/GraphicsLayer",])
		.then(([Map, GraphicsLayer]) => {
			const testLayer = new GraphicsLayer()
			testLayer.id = 'testlayer'
			vm.stateMap.addLayer(testLayer)

/*			vm.stateMap.graphicsLayerIds.forEach((graphicsLayerId) => {
		  		const gLayer = vm.stateMap.getLayer(graphicsLayerId);
		  		console.log(gLayer.id)
	  		})*/
		})
	},

	getMapCenter () {
		return new Promise((resolve, reject) => {
			const vm = state
			loadModules(["esri/map", "esri/geometry/webMercatorUtils"])
			.then(([Map, webMercatorUtils  ]) => {
				resolve(webMercatorUtils.webMercatorToGeographic(vm.stateMap.extent.getCenter()))
			})
		})
	},	

	gotoCoordinates ({state}, payload) {		
		const vm = state
		loadModules(["esri/map", "esri/geometry/Point"])
		.then(([Map, Point]) => {
			vm.stateMap.centerAt(new Point(payload.x, payload.y))
		})		
	},

	// Query initialInterior for graphics for one building floor and add to nullFeature layer
	addNullFeatures({commit, dispatch, state, getters, rootState}, payload) {
		console.log("Action: Add Null Features", payload)
		const vm = this
		
		loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/tasks/query", "esri/tasks/QueryTask",
					 "esri/symbols/SimpleLineSymbol", "esri/symbols/SimpleFillSymbol", "esri/Color",])
		.then(([Map, GraphicsLayer, Query, QueryTask, SimpleLineSymbol, SimpleFillSymbol, Color]) => {


			// This will pull from the InteriorInitial service which can be used to bypass the longer nightly workflow
			
			var features = []
			let esriToken     = jscookie.get(AUTH_COOKIE)
			//console.log("Current Floor", payload.floor)
			let URL = getters.initialFeaturesURL[payload.floor]
			var nullSymbol = new SimpleFillSymbol("solid",  new SimpleLineSymbol("solid", new Color([0,181,0]), 5),new Color([255,255,255,0]));
            let featureLayer = state.stateMap.getLayer('nullfeaturelayer')
            //let roominteractivityLayer = state.stateMap.getLayer('roominteractivitylayer')

			var queryTaskInitial = new QueryTask(URL)
			var queryInitial = new Query();

			queryInitial.returnGeometry = true;
			queryInitial.outFields = ["*"];
			
			queryInitial.where = "DocName" +" = '"+ payload.docName + "'";
			
			// This was from a previous method
			//let floor = payload.docName.split(".")[0].split("-")[1]
			//vm.commit('setCurrentFloor', floor)

			queryTaskInitial.on("complete", (event) => {
				//state.clearGraphics() 
				features = event.featureSet.features;

				if (features.length > 0) {	
					//console.log("addNullFeatures Count:", features.length)
					features.forEach(function(feature) {
						//roominteractivityLayer.add(feature);
						feature.setSymbol(nullSymbol);
						featureLayer.add(feature);
						
					});
					state.stateMap.setExtent(esri.graphicsExtent(features).expand(1.25));

					const payload2 = payload.docName.split("-")[0].replace(/^0+/, '') // removes leading zeros
					vm.commit('updateSelectionCentering', false)
					vm.dispatch('selectBuilding', payload2)
					vm.dispatch('symbolizeNullFeatureLayer', payload2)
				} else {
				 	commit('setSnackText', "No Features on this floor.  Choose correct floor first.")
				}

				dispatch('addCADTextToInteriorInitial', payload)
			})

			//console.log(queryInitial)
			queryTaskInitial.execute(queryInitial);

			// This will pull from the existing and processes FGDB for Interior Services
			// When this is active, it allows for fixing/reassociating individual rooms in Interior service.
			// Not sure what this was disabled though.
			
/*			features = []
			URL = rootState.user.viewRestricted ? secureFloorURL[rootState.ui.currentFloor] + '?token='+esriToken : floorURL[rootState.ui.currentFloor]

			var queryTask = new QueryTask(URL)
			var query = new Query();

			query.returnGeometry = true;
			query.outFields = ["*"];
			
			query.where = "DocName" +" = '"+ payload.docName + "'";
			console.log(query.where)
			commit('setDrawingLoading', true)
			queryTask.on("complete", function(event) {
				commit('setDrawingLoading', false)
				features = event.featureSet.features;

				if (features.length > 0) {	
					features.forEach(function(feature) {
						feature.setSymbol(nullSymbol);
						featureLayer.add(feature);
					});
					state.stateMap.setExtent(esri.graphicsExtent(features).expand(1.25));

					const payload2 = payload.docName.split("-")[0].replace(/^0+/, '') // removes leading zeros
					vm.dispatch('selectBuilding', payload2)
					vm.dispatch('symbolizeNullFeatureLayer', payload2)
				} 
			})

			queryTask.execute(query);*/

		})

	},

	// Adds original text from CAD drawings to the map to aid in room association
	// Query the 'Text_' point layers in initialInterior
	// And add labels to the map
	addCADTextToInteriorInitial({commit, state, getters, rootState}, payload) {
		console.log("Action: Add CADText to InteriorInitial", payload)		
		const vm = this
		
		loadModules(["esri/map", "esri/graphic", "esri/layers/GraphicsLayer", "esri/tasks/query", "esri/tasks/QueryTask",
					 "esri/symbols/SimpleMarkerSymbol", "esri/symbols/TextSymbol", "esri/Color", "esri/symbols/Font"])
		.then(([Map, Graphic, GraphicsLayer, Query, QueryTask, SimpleMarkerSymbol, TextSymbol, Color, Font]) => {

			let scaledFontSize = { // This would work if the function was recalled on every zoom change.  Not currently implemented.
			    "20": 10,
			    "21": 10, 
			    "22": 10,
			    "23": 10, 
			    "24": 10,
			    "25": 10,
			    "26": 10,
			    "27": 10,
			    "28": 12,
			    "29": 12,
			    "30": 12,
			    "31": 14,
			    "32": 14,
			    "33": 16,
			}

			var features = []
			let URL = getters.initialTextURL[payload.floor]

            const labelLayer = state.stateMap.getLayer('cadtextlayer') 

			var queryTask = new QueryTask(URL)
			var query = new Query();

			query.returnGeometry = true;
			query.outFields = ["*"];			
			query.where = "DocName" +" = '"+ payload.docName + "'";

			queryTask.on("complete", (event) => {
				features = event.featureSet.features;
				console.log("Text Features", features)

				if (features.length > 0) {	
					console.log("addNullFeatures Count:", features.length)
					features.forEach(function(feature) {
						const label = new TextSymbol()
							.setColor([0,0,0])
							.setAlign(Font.ALIGN_START)
							.setFont(new Font(`${scaledFontSize[rootState.mapFunctions.stateMap.getLevel()]}pt`)
							.setWeight(Font.WEIGHT_NORMAL).setFamily('Comic Sans MS')) ; 

						label.setText(feature.attributes['Text'])

						// Create a new label graphic at the center of the room interactivity graphic, and add it to the layer.
						var labelGraphic = new Graphic(feature.geometry, label);

						// Add Label Graphic to labelLayer
						labelLayer.add(labelGraphic);
					})

				} 
			})

			//console.log(query)
			queryTask.execute(query);
		})

	},

	// Symbolize local graphic layer.  This is only for initialInterior
	symbolizeNullFeatureLayer({dispatch, state, rootState}, payload) {
		if (!payload) { return}
		console.log("Symbolize initial Features: ", payload)

		loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", "esri/symbols/SimpleLineSymbol", 
					 "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic",	"esri/symbols/TextSymbol", "esri/symbols/Font",	])
		.then(([Map, GraphicsLayer, graphicsUtils, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic, TextSymbol, Font ]) => {
			const nullfeatureLayer = state.stateMap.getLayer('nullfeaturelayer')
			const customlabelLayer = state.stateMap.getLayer('customlabellayer')
			var symbol = new SimpleFillSymbol("solid",
							new SimpleLineSymbol("solid", new Color([0, 0, 0, 2]), 1),
							new Color([100, 255, 100, .3]));
			var nullSymbol = new SimpleFillSymbol("solid",  new SimpleLineSymbol("solid", new Color([0,0,0]), 1),new Color([255,100,100,.3]));
			// symbol is green, nullSymbol is red

			symbolize()

			async function symbolize() {
				//Numbering behaves if we force this load each time.  I dont' know why.
				//if (rootState.space.buildingRooms.length == 0) {
					//await dispatch('fetchSelectedBuildingFloorRooms') // This was breaking room association
				await dispatch('fetchSelectedBuildingRooms')
				//}
				state.clearGraphics('customlabellayer')

				// For each feature in nullfeatureLayer, look in all buildingRooms for a match based on JoinKey (dwgName+ehandle)
				// If there is a match, color it green, if no match, color it red
				// Also create a room number label and add to customlabelLayer
				nullfeatureLayer.graphics.forEach((feature) => {
					if (!feature.attributes) { console.log("Found Label"); return}
					//console.log(feature.attributes)
					let room = null
					room = rootState.space.buildingRooms.find((room) => { return room.dwgName + '.dwg+' + room.ehandle == feature.attributes["Join_Key"]}) 	
					if (room) {
						

						let customLabel = new TextSymbol().setColor(
										    new Color([128,0,0])).setAlign(Font.ALIGN_START).setFont(
										    new Font('8pt').setWeight(Font.WEIGHT_BOLD).setFamily('Roboto,sans-serif')) ; 
						let labelText = room.number
						customLabel.setText(labelText)	
						let gExt = feature.geometry.getExtent()
	    				let gCenter = gExt.getCenter()
						let labelGraphic = new Graphic(gCenter, customLabel); 	
						customlabelLayer.add(labelGraphic)
						feature.setSymbol(symbol)	
					} else {
						feature.setSymbol(nullSymbol)
					}
				})	
			}			


		})
	},

	centerOverRooms({state, getters, rootState}, payload) {
		let esriToken     = jscookie.get(AUTH_COOKIE)
		loadModules(["esri/map", "esri/tasks/query", "esri/tasks/QueryTask", "esri/graphicsUtils",					])
		.then(([Map, Query, QueryTask, graphicsUtils ]) => {
			const serviceURL = rootState.user.viewRestricted ? getters.secureFloorURL[rootState.ui.currentFloor] + '?token='+esriToken : getters.floorURL[rootState.ui.currentFloor]			
			
			const roomKeys = payload.rooms.map((room) => { return room.roomKey    })
			const arraystring = roomKeys.map((key) => {  return "'" + key + "'"	})			
			const where = "ROOMEXT.roomKey in (" + arraystring + ")";

	        var queryTask = new QueryTask(serviceURL);
						        var query = new Query();
						        query.returnGeometry = true;
						        query.outFields = ["*"];
						        query.where = where; 

	        queryTask.on("complete", function (event) { 
	        	state.stateMap.setExtent(esri.graphicsExtent(event.featureSet.features).expand(2))
	        })	

	        queryTask.execute(query);
		})
	},

	highlightInitialFeatures({state, rootState}, payload) {
		loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", "esri/symbols/SimpleLineSymbol", 
					 "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic",					])
		.then(([Map, GraphicsLayer, graphicsUtils, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic ]) => {
			let joinKeyArray = payload.joinKeyArray
			console.log("Highlight Array of Initial Features")

			const symbol = new SimpleFillSymbol("solid",
				new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([181, 0, 0, .8]), 5),
				new Color([181, 0, 0, .1]));

			const nullfeatureLayer = state.stateMap.getLayer('nullfeaturelayer')
			const highlightLayer = state.stateMap.getLayer('highlightlayer')
			state.clearGraphics('highlightlayer')  

			joinKeyArray.forEach((joinKey) => {
				let fGraphic = nullfeatureLayer.graphics.find(graphic => {return graphic.attributes["Join_Key"] === joinKey});

				if (fGraphic) {  
			    		let hGraphic = new Graphic(fGraphic.toJson())  // Copy object
			    		hGraphic.setSymbol(symbol)
						highlightLayer.add(hGraphic)
				}			
			})	

			// Center on graphics in highlight layer if specified
			state.stateMap.setExtent(esri.graphicsExtent(highlightLayer.graphics).expand(5))
			

		})
	},

	highlightNullFeature({state, rootState}, payload) {
		loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", "esri/symbols/SimpleLineSymbol", 
					 "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic",					])
		.then(([Map, GraphicsLayer, graphicsUtils, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic ]) => {
			let joinKey = payload.joinKey
			let multiSelect = payload.multiSelect
			console.log("Highlight Null Feature: ", joinKey)

			var symbol = new SimpleFillSymbol("solid",
							new SimpleLineSymbol("solid", new Color([255, 0, 0, 1]), 8),
							new Color([255, 0, 0, 0]));

			const nullfeatureLayer = state.stateMap.getLayer('nullfeaturelayer')
			const highlightLayer = state.stateMap.getLayer('highlightlayer')

			const fGraphic = nullfeatureLayer.graphics.find(graphic => {return graphic.attributes["Join_Key"] === joinKey});
			
			//console.log("Highlight Null Feature")

			if (fGraphic) {  
					//fGraphic.attributes["Room_Key"] = "Set"  // This could be where we update the GIS Service

		    		const hGraphic = new Graphic(fGraphic.toJson())  // Copy object
		    		hGraphic.setSymbol(symbol)
		    		if (!multiSelect) { 
		    			state.clearGraphics('highlightlayer')  
		    		}
	    			
					highlightLayer.add(hGraphic)
			}
		})
	},

	hoverHighlightNullFeature({state, rootState}, payload) {

		loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", "esri/symbols/SimpleLineSymbol", 
					 "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic",					])
		.then(([Map, GraphicsLayer, graphicsUtils, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic ]) => {
			let joinKey = payload.joinKey
			var symbol = new SimpleFillSymbol("solid",
							new SimpleLineSymbol("solid", new Color([0, 0, 255, 1]), 8),
							new Color([255, 0, 0, 0]));

			const nullfeatureLayer = state.stateMap.getLayer('nullfeaturelayer')
			const hoverhighlightLayer = state.stateMap.getLayer('hoverhighlightlayer')
			let keyName = "R_Level_" + rootState.ui.currentFloor + ".Join_Key"
			let keyNameInitial = "Join_Key"

			const fGraphic = nullfeatureLayer.graphics.find(graphic => {return graphic.attributes[keyNameInitial] === joinKey || 
																			   graphic.attributes[keyName] === joinKey});

			if (fGraphic) {    
		    		const hGraphic = new Graphic(fGraphic.toJson())  // Copy object
		    		hGraphic.setSymbol(symbol)
	    			state.clearGraphics('hoverhighlightlayer') 
					hoverhighlightLayer.add(hGraphic)
			}
		})
	},

	mapCenterOnDrawing({state, getters, rootState}, payload) {	
		console.log("Action: mapCenterOnDrawing")
		let esriToken     = jscookie.get(AUTH_COOKIE)

		loadModules(["esri/map", "esri/tasks/query", "esri/tasks/QueryTask", "esri/graphicsUtils"
					])
		.then(([Map, Query, QueryTask, graphicsUtils ]) => {
			const serviceURL = rootState.user.viewRestricted ? getters.secureFloorURL[rootState.ui.currentFloor] + '?token='+esriToken : getters.floorURL[rootState.ui.currentFloor]

			var queryTask = new QueryTask(serviceURL);
			var query = new Query();
							query.returnGeometry = true;
							query.outFields = ["*"];
							query.where = "R_Level_" + rootState.ui.currentFloor + ".DocName" +" = '"+ payload + "'";		

			queryTask.on("complete", function(event) {
				var features = event.featureSet.features;
				if (features.length > 0) { state.stateMap.setExtent(esri.graphicsExtent(features).expand(1.25)); }
			});

			queryTask.execute(query);
			this.dispatch('symbolizeNullFeatureLayer')
		})
	},

	buildingHoverHighlight({state, rootState}, graphic) {
		//console.log("Action: buildingHoverHighlight")
		const buildinghoverhighlightLayer = state.stateMap.getLayer('buildinghoverhighlightlayer')
  		// Clean up
  		buildinghoverhighlightLayer.clear()

  		// Make a copy.  Symbolize it and add it to the map.
  		let hGraphic  = graphic.clone()
  		hGraphic.setSymbol(rootState.mapSymbols.buildingHoverHighlightSymbol)
		buildinghoverhighlightLayer.add(hGraphic)

  	},

  	// Adds the floor/door swing details found in floorplans to the map for one building
	addFloorPlanDetail({state, rootState, getters, dispatch}, bldgAlpha) {
		loadModules(['esri/tasks/QueryTask', 'esri/tasks/query'])
  		.then(async ([QueryTask, Query]) => {

  			// check to see if user has turned off lineDetail
  			if (!rootState.ui.showLineDetail) { return }
  			
  			let esriToken   = jscookie.get(AUTH_COOKIE)
			const planLayer = state.stateMap.getLayer('planlayer')
			
			
			let data = rootState.space.buildingFiles || await dispatch('fetchBuildingFiles', bldgAlpha)

			// get the record for current floor
			let index = data.findIndex((row) => row.floor == rootState.ui.currentFloor)

			// get its DocName
			let DocName = data[index].CADName

			// Abort if this docName is already in the graphics layer.  Deduplicates and prevents a fetch
			let foundGraphic = planLayer.graphics.findIndex((graphic) =>  graphic.attributes.DocName == DocName )
			if (foundGraphic != -1) { 
				//console.log(DocName, "was already loaded")
				return 
			} 

			//console.log("Fetch and Add Floorpland Detail")		
			
			// Setup a Query to fetch features from EGIS Service
			var features = []
			const serviceURL = rootState.user.viewRestricted ? getters.securePlanURL[rootState.ui.currentFloor] + '?token='+esriToken : getters.planURL[rootState.ui.currentFloor]
			var queryTask = new QueryTask(serviceURL)

			var query = new Query();
				query.returnGeometry = true;
				query.outFields = ["*"];
				query.where = "DocName = '" + DocName + "'"

			// Execute the Query
			let results = await queryTask.execute(query)
			
			// Process the results			
			features = results.features
			if (features.length > 0) {
				features.forEach((feature) => {
					//Symbolize it and add it to the map.
					feature.symbol = rootState.ui.darkTheme ? rootState.mapSymbols.darkPlanLineSymbol : rootState.mapSymbols.planLineSymbol			

					// Prevents duplicate graphics from building up
					if (planLayer.graphics.findIndex((graphic) => 
						graphic.attributes.DocName == feature.attributes.DocName) == -1) {
						planLayer.add(feature);
					} 
				})
			} 
		})
	},

	// Will load graphics for rooms within the current extent and label them with room numbers
	loadRIForExtent({state, getters, rootState, commit, dispatch}) {
		loadModules(['esri/tasks/QueryTask', 'esri/tasks/query', 'esri/Color', 'esri/symbols/SimpleFillSymbol', 
  			'esri/symbols/SimpleLineSymbol'])
		.then(async ([QueryTask, Query, Color, SimpleFillSymbol, SimpleLineSymbol]) => {		
			//console.log("Load RI For Extent")

			if (state.stateMap.getLevel() > 18) {	// Only draw graphics zoomed in
				let esriToken     = jscookie.get(AUTH_COOKIE)
				const roominteractivityLayer = 	state.stateMap.getLayer('roominteractivitylayer')
				const nullfeatureLayer = 		state.stateMap.getLayer('nullfeaturelayer')
				const darkTheme = rootState.ui.darkTheme

				// This symbolMap can be used to pre symbolize by category
				var symbolMap = {
					"Circulation Area" : darkTheme ? rootState.mapSymbols.darkerGray : rootState.mapSymbols.graySymbol,	// Deemphasize circulation space
					null 			   : rootState.mapSymbols.nullSymbol,
				}

				// Setup a Query for this extent
				var features = []
				const serviceURL = rootState.user.viewRestricted ? getters.secureFloorURL[rootState.ui.currentFloor] + '?token='+esriToken : getters.floorURL[rootState.ui.currentFloor]

				var queryTask = new QueryTask(serviceURL)
				var query = new Query();
					query.returnGeometry = true;
					query.geometry = state.stateMap.extent
					query.outFields = ["*"];

				// Execute the Query
				let results = await queryTask.execute(query)

				// Process the Results.  Symbolize Features.  Add them to map.
				features = results.features

				// Clear layers
				roominteractivityLayer.clear()
				
				// 10-28-22 Removed.  This was making it impossible to do initialInterior Associations.  Not sure how it ever worked with this here.
				// nullfeatureLayer.clear() 
				// Do not think this will cause problems, but it will let nullfeatures stack up in the RI Layer.

				if (features.length > 0) {	

					// Experimented with only drawing new graphics and removing ones that move off extent
					// Complex and no real performance advantage.

					

					
					features.map(function(feature) {
						let roomCategory = feature.attributes['ROOMEXT.RoomCategory']
						
						// Custom symbology for some Room Categories
						if (symbolMap[roomCategory]) {
							feature.symbol = symbolMap[roomCategory]
						} else {
							feature.symbol = darkTheme ? rootState.mapSymbols.darkInteriorSymbol : rootState.mapSymbols.interiorSymbol
						}

						// Evaluate room category for symbol to use and add Graphic to Map
						// This is a proxy test that the GIS feature has been joined to the database record
						// When null it is assumed that association is not present and symbolized dark gray.
						if (roomCategory) {
							roominteractivityLayer.add(feature);
						} else {
							feature.symbol=rootState.mapSymbols.nullSymbol     
							nullfeatureLayer.add(feature)  
						}
					})

					//console.log("RI Graphics Count: ", roominteractivityLayer.graphics.length)
					

					// If user option allows, show floor plan detail
					rootState.ui.showLineDetail && rootState.space.selectedBuilding && dispatch('addFloorPlanDetail', rootState.space.selectedBuilding.bldgAlpha)
				} 
			} 
			dispatch('labelRoomNumbers') // will clear and label rooms
		})

	},

	// Used by search results
	addCrossCampusRoomInteractivity({state, getters, rootState}, payload) {	
		const deptID = payload
		const uniqueKey = Math.floor((Math.random() * 1000) + 1);
		console.log("addRoomInteractivity: id"+uniqueKey)
		console.log("Action: Add Cross Campus RoomInteractivity")
		const vm = state
		
		loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/tasks/query", "esri/tasks/QueryTask",
					 "esri/symbols/SimpleLineSymbol", "esri/symbols/SimpleFillSymbol", "esri/Color",])
		.then(([Map, GraphicsLayer, Query, QueryTask, SimpleLineSymbol, SimpleFillSymbol, Color]) => {

			const transparentSymbol = new SimpleFillSymbol("solid",
				new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 0, 0]), 5),
				new Color([255, 0, 0, 0]));
			
			let features = []
				if (deptID) { 
					let esriToken     = jscookie.get(AUTH_COOKIE)
					const serviceURL = rootState.user.viewRestricted ? getters.secureFloorURL[rootState.ui.currentFloor] + '?token='+esriToken : getters.floorURL[rootState.ui.currentFloor]
					const roominteractivityLayer = state.stateMap.getLayer('roominteractivitylayer')
					
					const queryTask = new QueryTask(serviceURL)
					const query = new Query();
					query.returnGeometry = true;
					query.outFields = ["*"];
					query.where = "ROOMEXT.DeptID = '" + deptID + "'";

					queryTask.on("complete", function(event) {
						state.clearGraphics('roominteractivitylayer')
						features = event.featureSet.features;
						
						if (features.length > 0) {	
						features.forEach(function(feature) {
							feature.setSymbol(transparentSymbol); 
							console.log("Add CC Room Interactive Graphics: id" + uniqueKey)
							roominteractivityLayer.add(feature);
						});

						console.log(roominteractivityLayer.graphics.length + " interactive graphics in layer.")
						} else { }
					})

					queryTask.execute(query);
				
				} else { //console.log("Asked for Graphics, but no Building Selected")
				}
		})			
	},

	addExtents({state, commit}, payload) {
		loadModules(["esri/geometry/Extent",])
		.then(([Extent]) => {	

			const tucsonExtent = new esri.geometry.Extent(
			    {	"xmin":-12354710.19351984,"ymin":3791275.297728251,"xmax":-12348346.810915107, "ymax":3796434.7971374933,
			    	"spatialReference":{"wkid":102100,"latestWkid":3857}  
			}); 

			const phoenixExtent = new esri.geometry.Extent(
			    {	"xmin":-12488188.354162911,"ymin":3944187.57281279,"xmax":-12456543.424452836,"ymax":3968953.169977197,
			    	"spatialReference":{"wkid":102100,"latestWkid":3857}  
			}); 

			commit('addSiteExtent', {'siteID': '10', 'extent': tucsonExtent})
			commit('addSiteExtent', {'siteID': '78', 'extent': phoenixExtent})

		})
	},
	

}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/mapFunctions.js